module.exports = __webpack_public_path__ + "static/media/cancel.f761acff.svg";